/**
 * @fileoverview HeaderMenu component.core
 *
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
import '../../lib/mobiscroll/navigation.react';
// Config Import
import AppConfig from '../../AppConfig';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';

/**
 * センタ―ヘッダーメニューコンポーネント
 *
 * @class HeaderMenu
 * @extends {Component}
 */
class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'clickMenu', 'clickRequestDateSelect');
  }

  /**
   * メニュークリック
   *
   * @param {Object} event event
   * @memberof HeaderMenu
   */
  clickMenu(event) {
    let dataset = event.target.dataset;
    // ボタン
    let url = event.target.id;
    // ハンバーガーメニューの場合
    if (!_.isEmpty(dataset.id)) {
      url = event.target.dataset.id;
    }
    // リンクの場合
    if (url.indexOf(AppConfig.httpScheme) !== -1) {
      window.location.href = url;
      return;
    }
    this.props.history.push(url);
  }

  /**
   * 予約日or予約時間選択へ遷移
   *
   * @returns
   * @memberof HeaderMenu
   */
  clickRequestDateSelect(event) {
    let url = event.target.dataset.id;
    // 予約一覧の場合
    if (url === ConstUtil.Common.COMPONENT.BOOKING_RECEPTION_LIST.URL) {
      this.props.history.push(url);
      return;
    }
    // 予約日・予約時間 表示モード取得
    let displayMode = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.BOOKING_DISPLAY_MODE
    );
    // 予約時間選択の場合
    if (displayMode === ConstUtil.Common.BOOKING_DISPLAY_MODE_LIST.TIME) {
      this.props.history.push(
        ConstUtil.Common.COMPONENT.REQUEST_TIME_SELECT.URL
      );
      return;
    }
    // 予約日選択の場合
    this.props.history.push(ConstUtil.Common.COMPONENT.REQUEST_DATE_SELECT.URL);
  }

  /**
   * センター管理者メニュー要素の描画
   *
   * @returns {Object} センター管理者メニュー要素
   * @memberof HeaderMenu
   */
  renderCenterManagerMenu() {
    return (
      <span>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID102}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.BOOKING_ASSIGN.URL}
          >
            {ConstUtil.Message.COMMON.ID105}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.BOOKING_RECEPTION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID104}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID114}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          {/* <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.RECEPTION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID113}
          </mobiscroll.NavItem> */}
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.CONGESTION_SITUATION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID115}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.FULL_EMPTY_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID120}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        {/* <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.ACHIEVEMENT_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID117}
        </mobiscroll.Button> */}
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID109}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          <mobiscroll.NavItem id={ConstUtil.Common.COMPONENT.USER_LIST.URL}>
            {ConstUtil.Message.COMMON.ID118}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.CONTRACTOR_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID119}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID110}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          <mobiscroll.NavItem id={ConstUtil.Common.COMPONENT.BERTH_SETTING.URL}>
            {ConstUtil.Message.COMMON.ID111}
          </mobiscroll.NavItem>
          {/* STEP2でのリリースのためコメントアウトしておく */}
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.MASTER_SETTING.URL}
          >
            {ConstUtil.Message.COMMON.ID121}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.CENTER_NOTICE_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID112}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
      </span>
    );
  }

  /**
   * バース作業者メニュー要素の描画
   *
   * @returns {Object} バース作業者メニュー要素
   * @memberof HeaderMenu
   */
  renderBerthWorkerMenu() {
    return (
      <span>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID102}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.BOOKING_ASSIGN.URL}
          >
            {ConstUtil.Message.COMMON.ID105}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.BOOKING_RECEPTION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID104}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID114}
          menuIcon=""
          onItemTap={this.clickMenu}
        >
          {/* <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.RECEPTION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID113}
          </mobiscroll.NavItem> */}
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.CONGESTION_SITUATION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID115}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.FULL_EMPTY_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID120}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        {/* <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.ACHIEVEMENT_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID117}
        </mobiscroll.Button> */}
        <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.CONTRACTOR_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID108}
        </mobiscroll.Button>
      </span>
    );
  }

  /**
   * 配送業者メニュー要素の描画
   *
   * @returns {Object} 配送業者メニュー要素
   * @memberof HeaderMenu
   */
  renderContractor() {
    return (
      <span>
        <mobiscroll.Button
          id={
            AppConfig.httpScheme +
            AppConfig.portalDomain +
            AppConfig.appPortNumber +
            ConstUtil.Common.PORTAL_URL_LIST.HOME
          }
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID101}
        </mobiscroll.Button>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID102}
          menuIcon=""
          onItemTap={this.clickRequestDateSelect}
        >
          <mobiscroll.NavItem>
            {ConstUtil.Message.COMMON.ID103}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.BOOKING_RECEPTION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID104}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.CONGESTION_SITUATION_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID114}
        </mobiscroll.Button>
        <mobiscroll.Button
          id={
            AppConfig.httpScheme +
            AppConfig.portalDomain +
            AppConfig.appPortNumber +
            ConstUtil.Common.PORTAL_URL_LIST.CAR
          }
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID106}
        </mobiscroll.Button>
        <mobiscroll.Button
          id={
            AppConfig.httpScheme +
            AppConfig.portalDomain +
            AppConfig.appPortNumber +
            ConstUtil.Common.PORTAL_URL_LIST.DRIVER
          }
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID107}
        </mobiscroll.Button>
      </span>
    );
  }

  /**
   * ドライバーメニュー要素の描画
   *
   * @returns {Object} ドライバーメニュー要素
   * @memberof HeaderMenu
   */
  renderDriver() {
    return (
      <span>
        <mobiscroll.Button
          id={
            AppConfig.httpScheme +
            AppConfig.portalDomain +
            AppConfig.appPortNumber +
            ConstUtil.Common.PORTAL_URL_LIST.HOME
          }
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID101}
        </mobiscroll.Button>
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          menuText={ConstUtil.Message.COMMON.ID102}
          menuIcon=""
          onItemTap={this.clickRequestDateSelect}
        >
          <mobiscroll.NavItem>
            {ConstUtil.Message.COMMON.ID103}
          </mobiscroll.NavItem>
          <mobiscroll.NavItem
            id={ConstUtil.Common.COMPONENT.BOOKING_RECEPTION_LIST.URL}
          >
            {ConstUtil.Message.COMMON.ID104}
          </mobiscroll.NavItem>
        </mobiscroll.HamburgerNav>
        <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.CONGESTION_SITUATION_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID114}
        </mobiscroll.Button>
      </span>
    );
  }

  /**
   * メニュー要素の描画
   *
   * @returns {Object} メニュー要素
   * @memberof HeaderMenu
   */
  renderMenu() {
    // 権限を取得
    let authorityId = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID
    );
    switch (authorityId) {
      // センター管理者
      case ConstUtil.Common.AUTHORITY_LIST.CENTER_MANAGER:
        return this.renderCenterManagerMenu();
      // バース作業員
      case ConstUtil.Common.AUTHORITY_LIST.BERTH_WORKER:
        return this.renderBerthWorkerMenu();
      // 配送業者
      case ConstUtil.Common.AUTHORITY_LIST.CONTRACTOR:
        return this.renderContractor();
      // ドライバー
      case ConstUtil.Common.AUTHORITY_LIST.DRIVER:
        return this.renderDriver();
      default:
        break;
    }
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof HeaderMenu
   */
  render() {
    return <div className="header-menu-area">{this.renderMenu()}</div>;
  }
}

HeaderMenu.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func })
};
export default withRouter(HeaderMenu);



// WEBPACK FOOTER //
// ./src/js/component/core/HeaderMenu.jsx